import {
  FETCH_JTBD_FOLDERS_VIDEOS,
  UPDATE_JTBD_ARCHIVED,
  UPDATE_JTBD_CONTENT,
  UPDATE_JTBD_DELETED,
  UPDATE_JTBD_FOLDERS_VIDEOS,
  UPDATE_JTBD_WATCHED,
} from 'constants/actions';

export const fetchJTBDFoldersVideos = () => {
  return { type: FETCH_JTBD_FOLDERS_VIDEOS };
};

export const updateJTBDArchived = archived => {
  return {
    type: UPDATE_JTBD_ARCHIVED,
    archived,
  };
};

export const updateJTBDContent = content => {
  return {
    ...content,
    type: UPDATE_JTBD_CONTENT,
  };
};

export const updateJTBDDeleted = deleted => {
  return {
    type: UPDATE_JTBD_DELETED,
    deleted,
  };
};

export const updateJTBDFoldersVideos = (folders, videos) => {
  return {
    type: UPDATE_JTBD_FOLDERS_VIDEOS,
    folders,
    videos,
  };
};

export const updateJTBDWatched = watched => {
  return {
    type: UPDATE_JTBD_WATCHED,
    watched,
  };
};
